const htmlDecode = (input: string): string => {
  const doc = new DOMParser().parseFromString(input, 'text/html')
  if (doc?.documentElement?.textContent) {
    return doc.documentElement.textContent
  }

  // should never be reachable
  // just in case it is, just return the original input
  return input
}

export {
  htmlDecode,
}
